import { gql } from "@apollo/client";

export const CREATE_UPDATE_SERVICE_AREA = gql`
  mutation createUpdateServiceArea($id: ID, $name: String, $path: [JSON]) {
    createUpdateServiceArea(id: $id, name: $name, path: $path)
  }
`;
